import { render } from "./BorderBottomLeftRadius.vue?vue&type=template&id=3e16039e&scoped=true&ts=true"
import script from "./BorderBottomLeftRadius.vue?vue&type=script&lang=ts"
export * from "./BorderBottomLeftRadius.vue?vue&type=script&lang=ts"

import "./BorderBottomLeftRadius.vue?vue&type=style&index=0&id=3e16039e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e16039e"]])

export default __exports__